
export const spans = [
    "range",
    "today",
    "yesterday",
    "thisWeek",
    "lastWeek",
    "thisMonth",
    "lastMonth",
    "thisYear",
    "lastYear",  
]


export const spanDisplayNames = {
    "range": "Range",
    "today": "Today",
    "yesterday": "Yesterday",
    "thisWeek": "This week",
    "lastWeek": "Last week",
    "thisMonth": "This month",
    "lastMonth": "Last month",
    "thisYear": "This year",
    "lastYear": "Last year",   
}

export const dateRangeRegex = /^\d{4}-\d{2}-\d{2}..\d{4}-\d{2}-\d{2}$/;
